import { ApolloError } from '@apollo/client';

const APPOINTMENT_UNAVAILABLE_TYPE = 'APPOINTMENT_UNAVAILABLE';

export class OrphanedBriefError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'OrphanedBriefError';
    }
}

export class DeprecatedRouteError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'DeprecatedRouteError';
    }
}

export class DuplicateBriefPurchaseError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'DuplicateBriefPurchaseError';
    }
}

/**
 * Detects the graph's APPOINTMENT_UNAVAILABLE error (the chosen DesignLive slot
 * was taken before booking completed). Accepts an ApolloError, a GraphQLError
 * array, or a single GraphQLError.
 */
export function isAppointmentUnavailableError(e: unknown): boolean {
    const graphQLErrors = e instanceof ApolloError ? e.graphQLErrors : Array.isArray(e) ? e : [e];

    return graphQLErrors.some(
        (err) =>
            (err as { extensions?: Record<string, unknown> })?.extensions?.type ===
            APPOINTMENT_UNAVAILABLE_TYPE
    );
}
